var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8314 6.45289L7.90602 0.197266L4.98211 6.45289L0 2.7988L1.51927 11.1042H14.2929L15.8122 2.7988L10.8314 6.45289Z",
    fill: "#FFD60A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.65924 11.8639H1.65764L1.65924 11.8737V14.2946H14.1664V11.8638L1.65924 11.8639Z",
    fill: "#FFD60A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioIcon2);
export default __webpack_public_path__ + "static/media/portfolio-icon2.7a15827bed2eb19b96439f073463acd4.svg";
export { ForwardRef as ReactComponent };